// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Viewport-sized panels for Orders and Returns only.
 * --orders-table-height is measured by the owning layout hook and includes
 * the space left after the page controls and bottom POS bar.
 */
.orders-responsive-table {
  box-sizing: border-box;
  display: flex;
  flex: 0 0 var(--orders-table-height);
  flex-direction: column;
  height: var(--orders-table-height);
  max-height: var(--orders-table-height);
  min-height: 0;
  overflow: hidden;
}

/* The Returns wrapper previously relied on a percentage height from its parent. */
.returns-table-wrapper.orders-responsive-table {
  min-height: 0;
}

.orders-responsive-table > .cpt__wrap {
  box-sizing: border-box;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  max-height: 100%;
}

.orders-responsive-table .cpt__table-scroll {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  max-height: none;
}

.orders-responsive-table .cpt__page-loader {
  flex: 1 1 auto;
  min-height: 0;
}

.orders-responsive-table > .cpt__empty {
  box-sizing: border-box;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
}

.orders-responsive-table .cpt__pagination {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/hooks/viewportTable.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,sBAAsB;EACtB,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kCAAkC;EAClC,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/*\n * Viewport-sized panels for Orders and Returns only.\n * --orders-table-height is measured by the owning layout hook and includes\n * the space left after the page controls and bottom POS bar.\n */\n.orders-responsive-table {\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 0 var(--orders-table-height);\n  flex-direction: column;\n  height: var(--orders-table-height);\n  max-height: var(--orders-table-height);\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* The Returns wrapper previously relied on a percentage height from its parent. */\n.returns-table-wrapper.orders-responsive-table {\n  min-height: 0;\n}\n\n.orders-responsive-table > .cpt__wrap {\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  height: 100%;\n  min-height: 0;\n  max-height: 100%;\n}\n\n.orders-responsive-table .cpt__table-scroll {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  max-height: none;\n}\n\n.orders-responsive-table .cpt__page-loader {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.orders-responsive-table > .cpt__empty {\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  height: 100%;\n  min-height: 0;\n}\n\n.orders-responsive-table .cpt__pagination {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
